export enum BackupStatus {
    stoppedWithError = 'stopped_with_error',
    done = 'done',
    inProgress = 'in_progress',
    scheduled = 'scheduled'
}

export class BackupData {
    id!: string;
    createdAt?: string;
    idCompany!: string;
    startNumber!: string;
    endNumber!: string;
    status!: BackupStatus;
    emailUserMain!: string;
    url?: string;
    extras?: Record<string, any>;

    constructor({
                    id,
                    idCompany,
                    startNumber,
                    endNumber,
                    createdAt,
                    status,
                    url,
                    emailUserMain,
                    extras
                }: {
        id?: string;
        idCompany: string;
        startNumber: string;
        endNumber: string;
        createdAt?: string;
        status: BackupStatus;
        url?: string;
        emailUserMain: string;
        extras?: Record<string, any>;
    }) {
        Object.assign(this, {
            id,
            idCompany,
            startNumber,
            endNumber,
            createdAt,
            status,
            url,
            extras,
            emailUserMain
        });
    }

    public get translateStatus():string {
        const object = {
            [BackupStatus.scheduled]: 'Agendado',
            [BackupStatus.inProgress]: 'Processando',
            [BackupStatus.stoppedWithError]: 'Error',
            [BackupStatus.done]: 'Concluído',
        }
        return object[this.status] ?? 'unknown';
    }

    public get isDone():boolean {
        return this.status === BackupStatus.done;
    }

    static fromJson(json: Record<string, any>): BackupData {
        return new BackupData({
            id: json['id'],
            idCompany: json['idCompany'],
            startNumber: json['startNumber'],
            endNumber: json['endNumber'],
            createdAt: json['createdAt'],
            status: json['status'],
            emailUserMain: json['emailUserMain'],
            url: json['url'] ?? null,
            extras: json['extras'] ?? null
        });
    }
}
